module.exports = __webpack_public_path__ + "img/star-bg-mob.9ee66fe.png";